import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { KPISummaryRequest, KPISummaryExportRequest, KPISummaryItem } from "api";
import { ToggleButtonGroup } from "components";
import { setToLocalStorage } from "utils";
import { SCORECARD_PAGE, SELECTED_SITE_LOCAL_STORAGE_KEY } from "pages/authenticated/scorecard/consts";
import { CustomKpisSummaryTable, ExportExcelButton } from "./components";

export const CustomKpisSummaryTab = ({
    query,
    onRefetchReady
}: {
    query: KPISummaryRequest,
    onRefetchReady: (refetchFn: (query: any) => void) => void
}) => {
    const navigate = useNavigate();
    const [selectedView, setSelectedView] = useState(query.isDisaggregated ? 'Monthly' : 'Aggregated');
    const [currentQuery, setCurrentQuery] = useState<KPISummaryRequest>(query);
    const tableRefetchFn = useRef<((query: any) => void) | null>(null);

    const onOpenSelectedKpiHandler = (row: KPISummaryItem) => {
        const selectedSite = {
            id: row.siteId,
            name: row.siteName
        };
        setToLocalStorage(SELECTED_SITE_LOCAL_STORAGE_KEY, selectedSite);

        navigate(SCORECARD_PAGE.ABSOLUTE_PATH);
    };

    const handleTableRefetchReady = (refetchFn: (query: any) => void) => {
        tableRefetchFn.current = refetchFn;
        onRefetchReady((updatedQuery: KPISummaryRequest) => {
            setCurrentQuery(updatedQuery);
            refetchFn(updatedQuery);
        });
    };

    // Trigger refetch when selectedView changes
    useEffect(() => {
        if (tableRefetchFn.current) {
            const updatedQuery = {
                ...currentQuery,
                isDisaggregated: selectedView === 'Monthly'
            };
            setCurrentQuery(updatedQuery);
            tableRefetchFn.current(updatedQuery);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedView]);

    const updatedQuery = {
        ...currentQuery,
        isDisaggregated: selectedView === 'Monthly'
    };

    const exportQuery: KPISummaryExportRequest = {
        ...updatedQuery
    };

    const toggleOptions = [
        { value: 'Aggregated', label: 'Aggregated' },
        { value: 'Monthly', label: 'Monthly' }
    ];

    return (

        <div style={{ display: 'flex', flexDirection: 'column', maxWidth: 'calc(100vw - 148px)', width: '100%' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', paddingTop: '24px' }}>
                <ToggleButtonGroup
                    options={toggleOptions}
                    selectedValue={selectedView}
                    onValueChange={setSelectedView}
                />
                <ExportExcelButton query={exportQuery} />
            </div>
            <CustomKpisSummaryTable
                onScorecardIconClick={onOpenSelectedKpiHandler}
                query={updatedQuery}
                onRefetchReady={handleTableRefetchReady}
            />
        </div>
    );
}